import React from 'react';
import { motion } from 'framer-motion';
export function StickyAlertBar() {
  return <motion.div initial={{
    y: -50
  }} animate={{
    y: 0
  }} className="fixed top-0 left-0 right-0 z-50 bg-brand-red text-white py-2 px-4 text-center font-bold uppercase tracking-wider text-xs md:text-sm shadow-lg" data-id="element-193">
      <span className="animate-pulse" data-id="element-194">⚠️ Advertencia:</span> Este precio de
      lanzamiento termina pronto.
    </motion.div>;
}